import Const from 'const';
import {LateSwapCsvLineupsInterface} from 'components/organisms/late-swap/late-swap-interfaces';
import LateswapCsvLineupInterface from 'src/components/organisms/late-swap/services/lineup-view/lateswap-csv-lineup-interface';

class LateSwapCsvLineups implements LateSwapCsvLineupsInterface {
    constructor(
        public readonly items: LateswapCsvLineupInterface[] = [],
        public readonly loadingStatus: string = Const.LATESWAP_LOADING_STATUS_NOT_STARTED,
    ) {}
    getAllAsArr(): LateswapCsvLineupInterface[] {
        return [...this.items];
    }
    getOneByNumber(lineupNumber: number): LateswapCsvLineupInterface | null {
        const index = lineupNumber - 1;

        return this.items[index] || null;
    }
    getOneByEntryId(entryId: string): LateswapCsvLineupInterface | null {
        for (let item of this.items) {
            if (item.getEntryId() === entryId) {
                return item;
            }
        }

        return null;
    }
    hasLineups(): boolean {
        return !isEmpty(this.items);
    }
    getLoadingStatus(): string {
        return this.loadingStatus;
    }
    isLoadingStatusNotStarted(): boolean {
        return this.loadingStatus === Const.LATESWAP_LOADING_STATUS_NOT_STARTED;
    }
    isLoadingStatusInProgress(): boolean {
        return this.loadingStatus === Const.LATESWAP_LOADING_STATUS_IN_PROGRESS;
    }
    isLoadingStatusFinished(): boolean {
        return this.loadingStatus === Const.LATESWAP_LOADING_STATUS_FINISHED;
    }
}

const lateSwapCsvLineups = new LateSwapCsvLineups();

export default function (state = lateSwapCsvLineups, action) {
    switch (action.type) {
        case Const.LATESWAP_SET_CSV_LINEUPS:
            return new LateSwapCsvLineups(action.lineups, state.getLoadingStatus());

        case Const.LATESWAP_SET_LOADING_STATUS:
            return new LateSwapCsvLineups(state.getAllAsArr(), action.status);

        case Const.FILTER_BY_SLATE:
            return new LateSwapCsvLineups();

        default:
            return state;
    }
}
